/**
 * Viewport Preloader
 * -------------------
 * Switches lazy-loaded images to eager loading when they come within
 * ~1500px of the viewport. This prevents the visible "pop-in" effect
 * that occurs when images load only at the moment they enter view,
 * which is especially noticeable on parallax / sticky-scroll sections.
 */
(function () {
    'use strict';

    var ROOT_MARGIN = '1500px';

    function initPreloader() {
        var images = document.querySelectorAll('img[loading="lazy"]');
        if (!images.length) return;

        if (!('IntersectionObserver' in window)) {
            // Fallback: switch all lazy images to eager immediately
            images.forEach(function (img) {
                img.setAttribute('loading', 'eager');
            });
            return;
        }

        var observer = new IntersectionObserver(
            function (entries, obs) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        var img = entry.target;
                        img.setAttribute('loading', 'eager');
                        obs.unobserve(img);
                    }
                });
            },
            { rootMargin: ROOT_MARGIN }
        );

        images.forEach(function (img) {
            observer.observe(img);
        });
    }

    // Run once DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPreloader);
    } else {
        initPreloader();
    }
})();
